import type { JSX } from 'react'
import type { ILayoutBlockProps } from '../LayoutBlock'

import { LAYOUT_BLOCK_PADDINGS } from 'vars/index'
import {
  LayoutBlockAlignItems,
  LayoutBlockDirection,
  LayoutBlockJustifyContent,
} from '../LayoutBlock.h'
import { LayoutBlockAuthSC } from './LayoutBlockAuth.styled'

export interface ILayoutBlockAuthProps extends ILayoutBlockProps {}

export const LayoutBlockAuth = ({
  children,
  height = '100%',
  direction = LayoutBlockDirection.Column,
  alignItems = LayoutBlockAlignItems.Center,
  justifyContent = LayoutBlockJustifyContent.Center,
  paddings = LAYOUT_BLOCK_PADDINGS.SIZE_30,
  ...rest
}: ILayoutBlockAuthProps): JSX.Element => (
  <LayoutBlockAuthSC
    height={height}
    direction={direction}
    alignItems={alignItems}
    justifyContent={justifyContent}
    paddings={paddings}
    {...rest}
  >
    {children}
  </LayoutBlockAuthSC>
)
